import { Component, OnInit } from '@angular/core';

import { AppService } from '../../../services/app.service';

@Component({
    selector: 'app-notification-index',
    templateUrl: './notification-index.component.html'
})
export class NotificationIndexComponent implements OnInit {
    constructor(
        private app: AppService
    ) { }

    readonly tabs: { id: string, title: string }[] = [
        { id: 'inbox', title: 'notification_inbox' },
        { id: 'channels', title: 'notification_channelManagement' }
    ];

    activeTabId: number = 1;
   
    ngOnInit() {
        if (this.app.currentUser.rights.includes('NOTIFICATION.OUTBOX')) {
            this.tabs.unshift({ id: 'outbox', title: 'notification_outbox' });
        }
    }
}
